// assets/error-logger.js

function logError(message, source, lineno, colno, error) {
  var payload = {
    event: 'js_error',
    errorMessage: message,
    errorSource: source,
    errorLine: lineno,
    errorColumn: colno,
    errorStack: error && error.stack ? error.stack : null,
    pageURL: window.location.href,
    timestamp: new Date().toISOString()
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

// catch sync errors
window.addEventListener('error', function(evt) {
  // Note: resource-load errors (images, scripts) vs JS errors get different shapes
  logError(
    evt.message || 'Resource load error',
    evt.filename || (evt.target && evt.target.src) || null,
    evt.lineno,
    evt.colno,
    evt.error || null
  );
}, true);

// catch unhandled promise rejections
window.addEventListener('unhandledrejection', function(evt) {
  logError(
    evt.reason && evt.reason.message ? evt.reason.message : 'UnhandledRejection',
    null,
    null,
    null,
    evt.reason
  );
});
